import React, { useContext } from "react";
import ForbiddenErrorPage from "../ForbiddenErrorPage";
import PropTypes from "prop-types";
import { UserContext } from "../AuthGuard";

export default function RoleGuard({ roles = [], condition = true, children }) {
  const [user] = useContext(UserContext);

  const hasAccess = () => {
    if (!user) return false;
    if (!roles.includes(user.role)) return false;
    if (user.role === "admin") return true;

    // Evaluate the custom condition if user role check passed
    return condition;
  };

  return hasAccess() ? children : <ForbiddenErrorPage />;
}

RoleGuard.propTypes = {
  roles: PropTypes.array,
  condition: PropTypes.bool,
  children: PropTypes.node,
};
